<template>
    <div>
        <select class="form-select" v-model="document[field.index]" @change="onFieldSelected" @blur="onFocusOut">
            <option value="" disabled selected>Select {{field.name}}</option>
            <option v-for="fieldOption in field.metadata">{{fieldOption.value}}</option>
        </select>

        <div v-if="field.required && !isValid" class="invalid-element">
            {{field.name}} is required
        </div>
    </div>
</template>

<script>
    import FormValidator from "../utils/FormValidator";
    import DataService from "../services/DataService";

    export default {
        name: 'SelectControl',
        props: ['document', 'field', 'table'],
        data() {
            return {
                model: webase.model,
                service: new DataService(this.table.id),
                isValid: true
            }
        },
        methods: {
            onFieldSelected() {
                // TODO: answer question - should we update on change or when save button is clicked
            },
            onFocusOut() {
                let validator = new FormValidator(this.table, this.document)
                this.isValid = validator.isFieldValid(this.field)

                if (!this.isValid) {
                    return
                }

                if (this.document['id'] && this.document[this.field.index]) {
                    this.service.save(this.document)
                }
            }
        }
    }
</script>
